// =====================================================================
// Taskboard data facade — the ONE place the redesigned pages import
// their data operations from. It delegates to the real API
// (services/api.js) by default, and only routes to the isolated mock
// (taskboardMock.js) when the mock is explicitly enabled for local dev.
//
// Keeping this switch in one module means the pages never branch on the
// mock flag themselves, and the production path is unconditionally the
// real API.
// =====================================================================

import * as api from "./api";
import { isMockEnabled, mock } from "./taskboardMock";

const mockOn = () => isMockEnabled();

export const taskboard = {
  getFolders: (params) => (mockOn() ? mock.getFolders(params) : api.getAgencyFolders(params)),
  getFolderDetail: (id) => (mockOn() ? mock.getFolderDetail(id) : api.getAgencyFolderDetail(id)),
  createFolder: (playerId) => api.createAgencyFolder(playerId), // real even in mock: creation stays real
  deleteFolder: (id) => api.deleteAgencyFolder(id),
  getRosterPlayers: (params) => (mockOn() ? mock.getRosterPlayers(params) : api.getAgencyPlayers(params)),

  getEntries: (id) => (mockOn() ? mock.getEntries(id) : api.getAgencyFolderEntries(id)),
  createEntry: (id, p) => (mockOn() ? mock.createEntry(id, p) : api.createAgencyFolderEntry(id, p)),
  patchEntry: (id, entryId, p) => (mockOn() ? mock.patchEntry(id, entryId, p) : api.patchAgencyFolderEntry(id, entryId, p)),
  deleteEntry: (id, entryId) => (mockOn() ? mock.deleteEntry(id, entryId) : api.deleteAgencyFolderEntry(id, entryId)),

  addUpdate: (id, entryId, p) => (mockOn() ? mock.addUpdate(id, entryId, p) : api.createAgencyFolderEntryUpdate(id, entryId, p)),
  pinUpdate: (id, entryId, updId, pinned) => (mockOn() ? mock.pinUpdate(id, entryId, updId, pinned) : api.pinAgencyFolderEntryUpdate(id, entryId, updId, pinned)),

  getLinks: (id) => (mockOn() ? mock.getLinks(id) : api.getAgencyFolderLinks(id)),
  createLink: (id, p) => (mockOn() ? mock.createLink(id, p) : api.createAgencyFolderLink(id, p)),
  updateLink: (id, linkId, p) => (mockOn() ? mock.updateLink(id, linkId, p) : api.updateAgencyFolderLink(id, linkId, p)),
  deleteLink: (id, linkId) => (mockOn() ? mock.deleteLink(id, linkId) : api.deleteAgencyFolderLink(id, linkId)),

  searchTeams: (q, opts) => (mockOn() ? mock.searchTeams(q) : api.searchPickerClubs(q, opts)),
};

export { isMockEnabled };
